import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import qs from 'qs'


class WKRecordData extends React.Component {
    constructor(props) {
        super(props)
        this.postRecord = this.postRecord.bind(this)
        this.state = {
            height: 0
        }
    }

    componentDidMount() {
        const {scene, action, hasLiveroom} = this.props
        let height = 0
        if (document.querySelector('div.page')) {
            height = document.querySelector('div.page').clientWidth * 0.57 + 60
        }
        this.setState({scene, action, height})
        if (hasLiveroom) {
            this.postRecord(scene, action)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.hasLiveroom) {
            const {scene, action} = this.props
            this.postRecord(scene, action)
        }
    }

    postRecord(scene, action) {
        return axios.post('/api/record_teacher', qs.stringify({scene, action}))
    }

    onClickRecord() {
        const {scene} = this.props
        if (scene === 'index') {
            this.postRecord('index', 'click').then(() => {
                location.href = '/specials/activity/teacher'
            })
        }
        if (scene === 'liveroom') {
            this.postRecord('liveroom', 'click').then(() => {
                location.href = `/specials/activity/teacher?liveroom_id=${this.props.liveroomId}`
            })
        }
    }

    render() {
        if (this.props.scene === 'teacher_page' || !this.props.hasLiveroom) {
            return null
        }


        return (
            <div className={`wk-record-data ${this.props.scene === 'liveroom' ? 'wk-record-data__liveroom' :''}`}
                style={{top: this.props.scene === 'liveroom' ? this.state.height + 'px' : 'inherit'}}>
                <img onClick={this.onClickRecord.bind(this)} className="wk-record-teacher__img"
                     src='https://static-cos.lycheer.net/picture/7832811_a0000e7775feb0b6bbf99ded52c25d23.jpg-picmsg420'/>
            </div>
        )
    }
}

export default connect((state) => ({
    hasLiveroom: state.account.has_liveroom
}))(WKRecordData)



// WEBPACK FOOTER //
// ./src/components/wk/WKRecordData.js